var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeAutoServicesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 83,
    viewBox: "0 0 87 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_4857_1716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.6776 40.2184C80.8976 40.9984 79.8776 41.3884 78.8476 41.3884C77.8176 41.3884 76.8076 40.9984 76.0176 40.2184L71.5676 35.7684V51.6284C70.1076 51.1184 67.4576 48.8084 65.6876 47.2784C64.9476 46.6384 64.2476 46.0284 63.5676 45.4784V27.7684L44.4376 8.63835C44.0976 8.29835 43.6976 8.24835 43.4876 8.24835C43.2776 8.24835 42.8776 8.29835 42.5376 8.63835L23.4076 27.7684V42.7884C22.0176 43.6584 20.8776 44.6984 19.7976 45.6784C18.9776 46.4284 18.1276 47.1984 17.1476 47.9384C16.5476 48.3884 15.9776 48.7684 15.4076 49.0784V35.7684L10.9576 40.2184C9.39762 41.7784 6.85763 41.7784 5.29763 40.2184C4.51763 39.4384 4.12762 38.4184 4.12762 37.3884C4.12762 36.3584 4.51763 35.3384 5.29763 34.5584L36.8776 2.97835C38.6476 1.21835 40.9876 0.248352 43.4876 0.248352C45.9876 0.248352 48.3276 1.21835 50.0976 2.97835L81.6776 34.5584C83.2376 36.1284 83.2376 38.6584 81.6776 40.2184Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4876 40.2184C47.7789 40.2184 51.2576 36.7396 51.2576 32.4484C51.2576 28.1571 47.7789 24.6784 43.4876 24.6784C39.1964 24.6784 35.7176 28.1571 35.7176 32.4484C35.7176 36.7396 39.1964 40.2184 43.4876 40.2184Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4176 74.5383C79.2676 74.5383 79.1176 74.5384 78.9576 74.5284H77.7476C77.7376 68.3684 72.7276 63.3583 66.5676 63.3583C60.4076 63.3583 55.4076 68.3584 55.3876 74.4984C46.7176 74.4684 37.1576 74.4183 28.4576 74.3183C28.3376 68.2583 23.3676 63.3583 17.2776 63.3583C11.1876 63.3583 6.49762 67.9883 6.11762 73.8183C5.98762 73.8083 5.86762 73.8084 5.74762 73.7984C4.81762 73.7584 3.90762 73.4883 3.15762 72.9483C2.19762 72.2583 1.66762 71.3184 1.07762 69.7784C0.707625 68.8284 0.607625 66.8684 0.977625 65.9184C1.64762 64.1684 3.51763 64.9484 4.12763 62.6884C4.62763 60.8584 4.98762 56.4483 6.39762 55.2883C7.63762 54.2583 10.7776 54.4984 12.3776 54.2484C13.4676 54.0784 14.4676 53.8184 15.4076 53.4684C16.8676 52.9284 18.1976 52.1584 19.5576 51.1384C21.0976 49.9784 22.2676 48.8184 23.4076 47.8084C25.4776 45.9884 27.4376 44.6384 31.2276 44.6384H54.4376C56.8476 44.6384 58.5676 46.6584 60.4276 48.0884C61.3476 48.7984 62.4276 49.7483 63.5676 50.7383C65.0876 52.0483 66.7276 53.4283 68.2576 54.3983C69.0176 54.8783 69.7476 55.2483 70.4276 55.4683C77.9476 57.8683 85.6476 57.2284 86.2176 67.4384C86.4476 71.5384 83.8276 74.5383 79.4176 74.5383Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4576 74.5383C24.4576 75.1283 24.3876 75.7083 24.2376 76.2583C24.0676 76.9683 23.7876 77.6384 23.4176 78.2484C22.1676 80.3284 19.8776 81.7184 17.2776 81.7184C14.6776 81.7184 12.1976 80.2184 10.9776 77.9884C10.6376 77.3684 10.3876 76.6884 10.2476 75.9684C10.1476 75.5084 10.0976 75.0283 10.0976 74.5383C10.0976 74.3383 10.1076 74.1484 10.1276 73.9584C10.4176 70.2684 13.5076 67.3584 17.2776 67.3584C21.0476 67.3584 24.3076 70.4283 24.4376 74.2583C24.4576 74.3483 24.4576 74.4483 24.4576 74.5383Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7476 74.5284C73.7476 75.2284 73.6476 75.8984 73.4676 76.5284C73.2676 77.2484 72.9476 77.9184 72.5476 78.5284C71.2476 80.4484 69.0576 81.7184 66.5676 81.7184C64.0776 81.7184 61.8676 80.4483 60.5776 78.5083C60.1776 77.8983 59.8676 77.2283 59.6676 76.5083C59.4876 75.8783 59.3876 75.2183 59.3876 74.5383V74.5083C59.4076 70.5583 62.6076 67.3584 66.5676 67.3584C70.5276 67.3584 73.7376 70.5684 73.7476 74.5284Z",
    fill: "#00FFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_4857_1716",
    x: -0.0000186563,
    y: -0.0000265539,
    width: 86.9768,
    height: 83.7898,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.496757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.372568
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "screen",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4857_1716"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4857_1716",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_4857_1716"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "effect2_innerShadow_4857_1716",
    result: "effect3_innerShadow_4857_1716"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeAutoServicesIcon);
export default __webpack_public_path__ + "static/media/HomeAutoServicesIcon.0a82faf111b034c87c7146a350b5b20d.svg";
export { ForwardRef as ReactComponent };